import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-cxone-popout',
    templateUrl: './cxone-popout.component.html',
    styleUrls: ['./cxone-popout.component.scss']
})
export class CxonePopoutComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() context?: PopoutContext;

    public isDashboardProjection = false;

    constructor() { }

    ngOnInit(): void {
        this.isDashboardProjection = this.moduleManager?.container.dashboardManager.isDashboardProjection;
    }

    getPopoutUrl() {
        return this.context.url();
    }

    /** True to render with ngIf, false to hide */
    shouldRender(): boolean {
        // If isVisible callback is not null, use that. Otherwise, check the URL for non-empty
        if (this.context.isVisible)
            return this.context.isVisible();

        return (this.context.url?.()?.length ?? 0) > 0;
    }
}

export class PopoutContext {
    url: () => string;
    isVisible?: () => boolean;
    parameters?: any;
};
